export const strings = {
    appName: "Tournify",
    appNameShort: "Tournify",
    homeDesc: "Free Tournament management app for eSports. Host eSports tournaments easily with eSports points table maker, registration forms and team management.",
    aboutDesc: `Tournify is a software solution that lets eSports organiser conduct tournaments of with ease. It is packed with points table generator and registration forms.`,
    formDesc: "Add description about your tournament. Here, you can mention your tournament rules.",
    formAfterDesc: "Add a message to show after a successful registration."

}